import { render, staticRenderFns } from "./mallSetting.vue?vue&type=template&id=413daa80&scoped=true&"
import script from "./mallSetting.vue?vue&type=script&lang=js&"
export * from "./mallSetting.vue?vue&type=script&lang=js&"
import style0 from "./mallSetting.vue?vue&type=style&index=0&id=413daa80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413daa80",
  null
  
)

export default component.exports